<div id="modal-header">
  <span class="color-primary">{{ 'fleet.card.table.modal.editModelQty' | translate }}</span>
  <button mat-icon-button class="color-primary mic-icon-button-large" (click)="closeModal()">
    <mat-icon class="color-primary">close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <span>{{ truckModel }}</span>
  <span>{{ 'common.months.' + month | translate }} {{ year }}</span>

  <span class="scroller">{{ 'fleet.card.table.modal.modelQty' | translate }}</span>
  <mic-number-scroller [(value)]="modelQuantity" [(valid)]="modelQuantityValid" [step]="1" [min]="0" [max]="100" />
  <div id="oem-title">
    <span class="scroller">{{ 'fleet.card.table.modal.oemArrivals' | translate }}</span>
    <mat-icon class="color-primary" [matTooltip]="'fleet.card.table.modal.oemDetails' | translate">help</mat-icon>
  </div>
  <mic-number-scroller [(value)]="oemArrivals" [(valid)]="oemArrivalsValid" [step]="1" [min]="0" [max]="10" />
</mat-dialog-content>
<mat-dialog-actions>
  <button color="primary" mat-flat-button [mat-dialog-close]="editModelQuantity()"
          [disabled]="!isEditModelQuantityActive()">{{ 'fleet.card.table.modal.editModelQty' | translate }}
  </button>
</mat-dialog-actions>
